// ─── FIBRE DEALS ───────────────────────────────────────────────────────────
// To add images: replace null with your image URL

export const FIBRE = [
  {
    id: 1, name: 'Uncapped Prepaid Fibre 10Mbps', category: 'Prepaid Fibre',
    image: null,                   // ← ADD IMAGE URL HERE
    badge: 'BEST VALUE',
    speed: '10Mbps Download', data: 'Uncapped', fup: null,
    price: 279, wasPrice: null, save: null, term: null,
    note: 'Month-to-month R309. From R9/day. Win a trip overseas — sign up to enter.',
  },
  {
    id: 2, name: 'Home Fibre 10Mbps', category: 'Contract Fibre',
    image: null,                   // ← ADD IMAGE URL HERE
    badge: null,
    speed: '10Mbps', data: '200GB', fup: '200GB Hard Lock',
    price: 399, wasPrice: null, save: null, term: 36,
    note: 'Free Installation and Router for new customers.',
  },
  {
    id: 3, name: 'Home Fibre 20Mbps', category: 'Contract Fibre',
    image: null,                   // ← ADD IMAGE URL HERE
    badge: 'POPULAR',
    speed: '20Mbps', data: '400GB', fup: '400GB Hard Lock',
    price: 429, wasPrice: null, save: null, term: 36,
    note: 'Free Installation and Router for new customers.',
  },
  {
    id: 4, name: 'Home Fibre 30Mbps', category: 'Contract Fibre',
    image: null,                   // ← ADD IMAGE URL HERE
    badge: null,
    speed: '30Mbps', data: '600GB', fup: '600GB Hard Lock',
    price: 499, wasPrice: null, save: null, term: 36,
    note: 'Free Installation and Router for new customers.',
  },
  {
    id: 5, name: 'Home Fibre 50Mbps', category: 'Contract Fibre',
    image: null,                   // ← ADD IMAGE URL HERE
    badge: null,
    speed: '50Mbps', data: '1TB', fup: '1TB Hard Lock',
    price: 599, wasPrice: null, save: null, term: 36,
    note: 'Free Installation and Router for new customers.',
  },
  {
    id: 6, name: 'Home Fibre 100Mbps', category: 'Contract Fibre',
    image: null,                   // ← ADD IMAGE URL HERE
    badge: 'ULTRAFAST',
    speed: '100Mbps', data: '2TB', fup: '2TB Hard Lock',
    price: 699, wasPrice: null, save: null, term: 36,
    note: 'Free Installation and Router for new customers.',
  },
  {
    id: 7, name: 'S90 Ultra AI Router', category: 'Router Upgrade',
    image: null,                   // ← ADD IMAGE URL HERE
    badge: 'NEW',
    speed: null, data: null, fup: null,
    price: null, wasPrice: null, save: null, term: null,
    note: 'AI-powered router. Built-in battery 4 hrs. SIM auto-switches to LTE. Stronger signal. Save up to R5000.',
    features: ['AI-powered for smoother internet', 'Built-in battery keeps Wi-Fi on 4 hrs', 'Auto-switches to LTE if fibre drops', 'Stronger whole-home coverage'],
  },
];

export const FIBRE_CATEGORIES = ['All', 'Prepaid Fibre', 'Contract Fibre', 'Router Upgrade'];
